import React from 'react'
import { connect } from 'react-redux'

import { ReactModal } from '../../../../../components'
import { ERROR_ORDER, ORDER_MODAL_ACTION_TEXT } from '../../../../../helpers'
import { MODAL, ORDER } from '../../../../../reduxs'

import { CancelOrderModalStyle } from './styles'

function CancelOrderModal(props) {
  const {
    language,
    isOpenCancelOrderModal,
    setOrderId,
    openSuccessOrderModal,
    closeCancelOrderModal,
    clearOrderActionText,
    deleteOrder,
    setErrorModal,
    setIsEditOrder
  } = props

  const handleBack = () => {
    setOrderId(null)
    setIsEditOrder(false)
    clearOrderActionText()
    closeCancelOrderModal()
  }

  const handleDeleteOrder = async () => {
    const res = await deleteOrder()

    if(res.status) {
      setOrderId(null)
      openSuccessOrderModal()
      closeCancelOrderModal()
    } else {
      setOrderId(null)
      closeCancelOrderModal()
      setErrorModal(true, ERROR_ORDER.DELETE)
    }
  }

  return (
    <ReactModal isVisible={isOpenCancelOrderModal} width={440} borderRadius={8} >
      <CancelOrderModalStyle>
        <h2 className='cancel-order-modal__title'>
          {ORDER_MODAL_ACTION_TEXT.ARE_YOU_SURE[language]}
        </h2>
        <p className='cancel-order-modal__text'>
          {ORDER_MODAL_ACTION_TEXT.DO_YOU_WANT_TO_CANCEL_ORDER[language]}
        </p>
        <div className='cancel-order-modal__button'>
          <button
            className='cancel-order-modal__button--back'
            onClick={handleBack}
          >
            {ORDER_MODAL_ACTION_TEXT.BACK[language]}
          </button>
          <button
            className='cancel-order-modal__button--cancel'
            onClick={handleDeleteOrder}
          >
            {ORDER_MODAL_ACTION_TEXT.YES_CANCEL_ORDER[language]}
          </button>
        </div>
      </CancelOrderModalStyle>
    </ReactModal>
  )
}

const mapStateToProps = ({ accountReducer, orderReducer, modalReducer }) => {
  return {
    language: accountReducer.language,
    colorTheme: accountReducer.user.colorThemePalette,
    isOpenCancelOrderModal: modalReducer.orderModal.isOpenCancelOrderModal
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setEditOrderHashMap: (orderId) => dispatch(ORDER.action.setEditOrderHashMap(orderId)),
    setOrderId: (orderId) => dispatch(ORDER.action.setOrderId({ orderId })),
    setOrderActionEdit: (selectedTab) => dispatch(ORDER.action.setOrderActionText(selectedTab, 'EDIT')),
    openOrderCounterModal: () => dispatch(MODAL.action.setOrderCounterModal(true)),
    setIsEditOrder: (isEditOrder) => dispatch(ORDER.action.setIsEditOrder(isEditOrder)),
    setErrorModal: (isOpen, text) => dispatch(MODAL.action.setErrorModal(isOpen, text)),
    closeCancelOrderModal: () => dispatch(MODAL.action.setCancelOrderModal(false)),
    openSuccessOrderModal: () => dispatch(MODAL.action.setSuccessOrderModal(true)),
    clearOrderActionText: () => dispatch(ORDER.action.clearOrderActionText()),
    deleteOrder: () => dispatch(ORDER.action.deleteOrder()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelOrderModal)
